import { useTranslation } from 'react-i18next'
import { Typography, Tooltip } from '@mui/material'
import ChipStatus from 'packages/ui/ChipStatus'

import { STATUS } from '../../../constants'
import i18next from 'i18next'

const Status = ({service}) => {
  const {t } = useTranslation()
  return (
    <ChipStatus 
      status={t(`projects.table.status.${service.state}`)}
      color={STATUS[service.state]?.color || STATUS.standby.color}
      bgcolor={STATUS[service.state]?.bgcolor || STATUS.standby.bgcolor}
      height={24}
      borderRadius="50px"
    />
  )
}

const Category = ({service}) => {
  const {t} = useTranslation()
  return (
    <>
      {t(`projects.services.category.${service.category}`)}
      <br/>
      <Typography component={'span'} sx={{fontSize: 12, fontWeight: 600}}>{t(`projects.services.name.${service.name}`)}</Typography>
    </>
  )
}

const COLUMNS_CONFIG = [
  {
    name: 'status',
    header: {
      label: ctx => ctx.t('projects.table.status_col')
    },
    value: service => <Status service={service} />
  },
  {
    name: 'mes_at',
    header: {
      label: ctx => ctx.t('services.table.mes_at_col')
    },
    value: service =>
      service.commissioned_at ? new Date(service.commissioned_at).toLocaleDateString(i18next.language) : '-',
    sortBy: 'mes_at',
    sortable: true
  },
  {
    name: 'kind',
    header: {
      label: ctx => ctx.t('services.table.kind_col')
    },
    value: (service, ctx) => (
      <Tooltip title={ctx.t(`projects.services.kind.${service.kind}.tooltip`)} placement={'top'} arrow>
        <Typography sx={{ fontSize: 12, color: 'black' }}>{ctx.t(`projects.services.kind.${service.kind}.name`)}</Typography>
      </Tooltip>
    )
  },
  {
    name: 'service',
    header: {
      label: ctx => ctx.t('services.table.service_col')
    },
    value: service => <Category service={service} />
  },
  {
    name: 'detail',
    header: {
      label: ctx => ctx.t('services.table.detail_col')
    },
    value: (service, ctx) => ctx.t(`projects.services.detail.${service.name}`)
  }
]

export default COLUMNS_CONFIG